import { render, staticRenderFns } from "./associatedUsers.vue?vue&type=template&id=51c19af5&scoped=true"
import script from "./associatedUsers.vue?vue&type=script&lang=js"
export * from "./associatedUsers.vue?vue&type=script&lang=js"
import style0 from "./associatedUsers.vue?vue&type=style&index=0&id=51c19af5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c19af5",
  null
  
)

export default component.exports